export const DRAWER_WIDTH = 220;

export const navItems = [
  { label: "Home", path: "/home", icon: "home" },
  { label: "Games", path: "/games", icon: "♟" },
  { label: "Patterns", path: "/patterns", icon: "♜" },
  { label: "Focus", path: "/focus", icon: "focus" },
  { label: "Trends", path: "/trends", icon: "board-trend" },
  { label: "Nikola", path: "/chats", icon: "♞" },
  { label: "Analyze", path: "/analyze", icon: "♝" },
  { label: "Archive", path: "/archive", icon: "archive" },
  { label: "Board", path: "/board", icon: "chess-board" },
  { label: "Membership", path: "/subscription", icon: "♛" },
  { label: "Profile", path: "/profile", icon: "♚" },
  { label: "Settings", path: "/settings", icon: "settings" },
  { label: "Help", path: "/help", icon: "help-book" },
] as const;

export const isMobileNavItemActive = (pathname: string, path: string): boolean =>
  pathname === path || pathname.startsWith(`${path}/`);

export const isPrimaryNavigationDisabled = (onboardingCompleted: boolean): boolean => !onboardingCompleted;

export const titleForPath = (pathname: string): string => {
  if (pathname === "/" || pathname === "/home") return "Home";
  if (pathname === "/archive") return "Archive";
  if (pathname === "/login") return "Log In";
  if (pathname === "/signup") return "Create Account";
  if (pathname === "/games") return "Games";
  if (pathname.startsWith("/games/")) return "Game Review";
  if (pathname === "/patterns") return "Patterns";
  if (pathname === "/focus") return "Focus";
  if (pathname === "/study") return "Study";
  if (pathname === "/trends") return "Trends";
  if (pathname === "/chats" || pathname === "/chat") return "Nikola";
  if (pathname === "/analyze") return "Analyze";
  if (pathname === "/board") return "Board";
  if (pathname === "/profile") return "Profile";
  if (pathname === "/settings") return "Settings";
  if (pathname === "/subscription") return "Membership";
  if (pathname === "/about") return "About";
  if (pathname === "/help") return "Help";
  return "CHESSLA";
};
